const cssLintMessages = {
    "block-no-empty": "Não deixe blocos de CSS vazios.",
    "color-no-invalid-hex": "Use valores hexadecimais de cor válidos.",
    "declaration-block-semicolon-newline-after": "Adicione uma nova linha após o ponto e vírgula.",
    "declaration-block-trailing-semicolon": "Inclua um ponto e vírgula no final de cada declaração.",
    "property-no-unknown": "Certifique-se de que as propriedades CSS sejam válidas.",
    "font-family-no-missing-generic-family-keyword": "Adicione uma fonte genérica (como sans-serif) à lista de fontes.",
  };
  
  module.exports = cssLintMessages;
  